import { handleGetRequest } from '../../service/GetTemplate';
import { handleDeleteRequest } from '../../service/DeleteTemplate';
import { handlePatchRequest } from '../../service/PatchTemplate';
import { handlePostRequest } from '../../service/PostTemplate';

const withQuery = (base, params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.append(key, value);
        }
    });
    const queryString = query.toString();
    return queryString ? `${base}?${queryString}` : base;
};

export const getAgendaByWeek = (weekStartDate, agentId, dispatch) =>
    handleGetRequest(withQuery('sales/agendas', { weekStartDate, agentId }), false, false, dispatch, {
        requestName: 'sales-agenda-week',
        errorMessagePrefix: 'No pudimos cargar la agenda'
    });

export const getSalesAgents = (dispatch, weekStartDate) =>
    handleGetRequest(withQuery('sales/agents', { weekStartDate }), false, false, dispatch, {
        requestName: 'sales-agents',
        errorMessagePrefix: 'No pudimos cargar los vendedores'
    });

export const getSalesCustomers = (dispatch) =>
    handleGetRequest('sales/customers', false, false, dispatch);

export const getSalesCustomerContext = (businessUnit, quickBooksId, dispatch) =>
    handleGetRequest(
        `sales/customers/${encodeURIComponent(businessUnit)}/${encodeURIComponent(quickBooksId)}/context`,
        false,
        false,
        dispatch
    );

export const getSalesSettings = (dispatch) =>
    handleGetRequest('sales/settings', false, false, dispatch);

export const updateSalesSettings = (payload, dispatch) =>
    handlePatchRequest(payload, 'sales/settings', false, false)(dispatch);

export const resetSalesSettings = (payload, dispatch) =>
    handlePostRequest(payload, 'sales/settings/reset', false, false)(dispatch);

export const getWeeklyOverview = (weekStartDate, dispatch) =>
    handleGetRequest(withQuery('sales/weekly-overview', { weekStartDate }), false, false, dispatch, {
        requestName: 'sales-weekly-overview',
        errorMessagePrefix: 'No pudimos cargar el resumen semanal'
    });

export const getSellerCandidates = (dispatch) =>
    handleGetRequest('sales/agent-candidates', false, false, dispatch, {
        requestName: 'sales-agent-candidates',
        errorMessagePrefix: 'No pudimos cargar los usuarios elegibles'
    });

export const assignSellerProfile = (payload, dispatch) =>
    handlePostRequest(payload, 'sales/agents/assign-seller', false, false)(dispatch);

export const removeSellerProfile = (agentId, dispatch) =>
    handleDeleteRequest(`sales/agents/${agentId}`, false, false)(dispatch);

export const getTeamAgendaByWeek = (agentId, weekStartDate, dispatch) => getAgendaByWeek(weekStartDate, agentId, dispatch);

export const createAgenda = (payload, dispatch) => handlePostRequest(payload, 'sales/agendas', false, false)(dispatch);

export const createVisit = (agendaId, payload, dispatch) => handlePostRequest(payload, `sales/agendas/${agendaId}/visits`, false, false)(dispatch);

export const createOfficeActivity = (agendaId, payload, dispatch) =>
    handlePostRequest(payload, `sales/agendas/${agendaId}/office-activities`, false, false)(dispatch);

export const updateOfficeActivity = (visitId, payload, dispatch) =>
    handlePatchRequest(payload, `sales/office-activities/${visitId}`, false, false)(dispatch);

export const updateVisit = (visitId, payload, dispatch) => handlePatchRequest(payload, `sales/visits/${visitId}`, false, false)(dispatch);

export const cancelVisit = (visitId, cancellationReason, dispatch) =>
    handlePostRequest({ cancellationReason }, `sales/visits/${visitId}/cancel`, false, false)(dispatch);

export const submitAgenda = (agendaId, dispatch) => handlePostRequest({}, `sales/agendas/${agendaId}/submit`, false, false)(dispatch);

export const reviewAgenda = (agendaId, payload, dispatch) =>
    handlePostRequest(payload, `sales/agendas/${agendaId}/review`, false, false)(dispatch);

export const startVisit = (visitId, payload = {}, dispatch) => handlePostRequest(payload, `sales/visits/${visitId}/start`, false, false)(dispatch);

export const finishVisit = (visitId, payload = {}, dispatch) => handlePostRequest(payload, `sales/visits/${visitId}/finish`, false, false)(dispatch);

export const startUnplannedVisit = (payload, dispatch) => handlePostRequest(payload, 'sales/visits/unplanned/start', false, false)(dispatch);

export const startOfficeActivity = (visitId, payload = {}, dispatch) =>
    handlePostRequest(payload, `sales/office-activities/${visitId}/start`, false, false)(dispatch);

export const startUnplannedOfficeActivity = (payload, dispatch) =>
    handlePostRequest(payload, 'sales/office-activities/unplanned/start', false, false)(dispatch);

export const finishOfficeActivity = (visitId, payload = {}, dispatch) =>
    handlePostRequest(payload, `sales/office-activities/${visitId}/finish`, false, false)(dispatch);

export const getVisitReport = (visitId, dispatch) =>
    handleGetRequest(`sales/visits/${visitId}/report`, false, false, dispatch, {
        requestName: 'sales-visit-report',
        errorMessagePrefix: 'No pudimos cargar el reporte'
    });

export const saveVisitReport = (visitId, payload, dispatch) =>
    handlePatchRequest(payload, `sales/visits/${visitId}/report`, false, false)(dispatch);

export const saveLiveMeeting = (visitId, payload, dispatch) =>
    handlePatchRequest(payload, `sales/visits/${visitId}/live-meeting`, false, false)(dispatch);

export const submitVisitReport = (visitId, dispatch) =>
    handlePostRequest({}, `sales/visits/${visitId}/report/submit`, false, false)(dispatch);
